export const ANSWER_GRACE_MS = 15 * 60 * 1000;

const UNANSWERED = new Set(["not_yet_retrieved", "no_answer_returned"]);

const eventKey = (id) => (typeof id === "string" && id ? id.toLowerCase() : null);

const turnEventKey = (turn) => eventKey(
    Object.prototype.hasOwnProperty.call(turn, "observationSourceEventId") ? turn.observationSourceEventId : turn.sourceEventId,
);

export function isUnanswered(status) {
    return UNANSWERED.has(status);
}

export function unansweredPrompt({ eventId, eventTime, status }) {
    if (!isUnanswered(status) || !eventKey(eventId)) return null;
    return { eventId: eventKey(eventId), eventTime: Number.isFinite(eventTime) ? eventTime : null, status };
}

export function isOverdue(prompt, now = Date.now()) {
    return Number.isFinite(prompt?.eventTime) && now - prompt.eventTime >= ANSWER_GRACE_MS;
}

export function overdueAnswerCount(prompts, now = Date.now()) {
    return (prompts || []).filter((prompt) => isOverdue(prompt, now)).length;
}

export function answerGapLabel(count) {
    return count === 1 ? "1 answer missing" : `${count} answers missing`;
}

export function answerGapsByEvent(prompts, turns) {
    const answered = new Set(
        (turns || [])
            .filter((turn) => turn?.role === "assistant")
            .map(turnEventKey)
            .filter(Boolean),
    );
    const gaps = new Map();
    for (const prompt of prompts || []) {
        const key = eventKey(prompt?.eventId);
        if (key && !answered.has(key)) gaps.set(key, prompt);
    }
    return gaps;
}

export function answerGapForTurn(turn, gaps) {
    if (turn?.role !== "user" || !gaps?.size) return null;
    return gaps.get(turnEventKey(turn)) ?? null;
}

export function turnAnswerGapText(gap, now = Date.now()) {
    return isOverdue(gap, now)
        ? "No answer captured from Copilot."
        : "Waiting for Copilot's answer to be captured.";
}
